module.exports = __webpack_public_path__ + "static/media/LT.a9f6a389.svg";